import { clsx } from 'clsx'
import type { ReactNode } from 'react'

import { Text } from './Text.tsx'
import styles from './TodoList.module.scss'

interface TodoListProps {
  children: ReactNode
}

export function TodoList(props: TodoListProps) {
  const { children } = props
  return <ul className={styles.list}>{children}</ul>
}

interface TodoListItemTitleProps {
  children: ReactNode
  variant?: 'current' | 'completed'
}

function TodoListItemTitle(props: TodoListItemTitleProps) {
  const { children, variant } = props
  return (
    <Text
      className={clsx(styles.title, {
        [styles.titleCompleted]: variant === 'completed',
      })}
    >
      {children}
    </Text>
  )
}

interface TodoListItemDescriptionProps {
  children: ReactNode
}

function TodoListItemDescription(props: TodoListItemDescriptionProps) {
  const { children } = props
  return <div className={styles.description}>{children}</div>
}

interface TodoListItemProps {
  variant?: 'current' | 'completed'
  title: ReactNode
  description?: ReactNode
}

export function TodoListItem(props: TodoListItemProps) {
  const { description, variant, title } = props
  return (
    <li
      className={clsx(styles.item, {
        [styles.itemCurrent]: variant === 'current',
        [styles.itemCompleted]: variant === 'completed',
      })}
    >
      <TodoListItemTitle variant={variant}>{title}</TodoListItemTitle>
      {description && variant === 'current' && (
        <TodoListItemDescription>{description}</TodoListItemDescription>
      )}
    </li>
  )
}
